import { ApiDOMError } from '@swagger-api/apidom-error';

/**
 * @public
 */
class ResolveError extends ApiDOMError {}
export default ResolveError;